import gql from "graphql-tag";

export const MY_TEAMS_MApp_PULSE_CHECK = gql`
  query myTeamsMAppPulseCheck {
    myTeamsMAppPulseCheck
  }
`;
